import { useEffect, useRef } from "react";
import Style from "./VideoStatic.module.scss";

const VideoStatic = ({ entryId }: { entryId: string }): JSX.Element => {

    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const videoElement = videoRef.current;

        if (videoElement) {
            // Add event listeners if needed
            const handlePlay = () => {
                console.log('Video is playing');
            };

            const handlePause = () => {
                console.log('Video is paused');
            };

            const handleEnded = () => {
                console.log('Video has ended');
            };

            videoElement.addEventListener('play', handlePlay);
            videoElement.addEventListener('pause', handlePause);
            videoElement.addEventListener('ended', handleEnded);

            // Cleanup event listeners on component unmount
            return () => {
                videoElement.removeEventListener('play', handlePlay);
                videoElement.removeEventListener('pause', handlePause);
                videoElement.removeEventListener('ended', handleEnded);
            };
        }
    }, []);

    return (
        <div className={Style.videoContainer}>
            <video ref={videoRef} autoPlay loop muted className={Style.videoPlayer} >
                <source src={entryId} type="video/mp4" />
            </video>
        </div>
    );
};

export default VideoStatic;
